import { ShareLocation } from "@/handler/event/impl/action";
import { createInjectable } from "@shared/utils/dependency";

export const AbilityDependency = createInjectable({
    shareImage(_shortId: string, _longId: string, _location: ShareLocation, _ability_name: string, _success?: () => void) {

    }
})